<script>
  import gql from 'graphql-tag'
  import bookDefault from './book-default.vue'

  const findTitre = gql`
    query findTitre($id: String) {
      titre(id: $id) {
        id
        titre
        livres {
          id
        }
      }
    }
  `
  export default {
    name: 'Titre',
    props: {
      id: {},
    },
    data () {
      return {
        titre: null,
      }
    },
    components: {
      bookDefault,
    },
    apollo: {
      titre: {
        // returnPartialData: true,
        query: findTitre,
        variables () {
          return {
            id: this.id,
          }
        },
        skip () {
          return !this.id
        },
        // update(data) {
        //   // console.log(data.titre.livres[0].id)
        //   // return data.titre
        // },
      },
    },
    computed: {

    },
  }
</script>

<template lang="pug">

book-default(v-if="titre", :id="titre.livres && titre.livres[0].id")
  template(scope="{ livre }")
    slot(:titre="titre", :livre="livre")
</template>

<style lang="postcss" scoped>



  .book-default {


  }
</style>



// WEBPACK FOOTER //
// titre-default.vue?ffac9578